module.exports = __webpack_public_path__ + "img/plot-chart.fa3b8538.svg";